import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="AF" transform="translate(22.5, 5.000000)">
        <path
          d="M5,61 L10,61 L13,52 L22,52 L25,61 L30,61 L20,30.3 L15,30.3 L5,61 Z M14.5,47 L20.5,47 L17.5,38 L14.5,47 Z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
        />
        <path d="M20,43 L17.5,35 L15,43 Z" fill="none" />
        <path
          d="M35,61 L35,30.3 L50,30.3 L50,35 L40,35 L40,43 L48,43 L48,47.5 L40,47.5 L40,61 L35,61 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
